// extracted by mini-css-extract-plugin
export default {"container":"JXENN","tooltipContent":"gt3QN","successIcon":"Bie5e","textToCopy":"Dss07"};